export default __webpack_public_path__ + "static/media/workouttimes_1.71792604.jpg";